/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

/**
 * This is an error codes map used by explore apis
 */
export default {
	STARTP_INVALID_FOCUS_FIELD_INDEX: 'CA-EXP-STARTP-2000', // StartingPointsAPI::setFocusFieldIndex
	STARTP_INVALID_FOCUS_FIELD_ID: 'CA-EXP-STARTP-2001', // StartingPointsAPI::setFocusField
	STARTP_INVALID_SCOPE_FIELDS_LIST: 'CA-EXP-STARTP-2002', // StartingPointsAPI::setScopedFields
	STARTP_INVALID_FROM_TO_FIELD_ID: 'CA-EXP-STARTP-2003' // StartingPointsAPI::showRelationshipsBetween
};



// WEBPACK FOOTER //
// ./src/js/api/util/ErrorCodes.js